<template>
  <LeftPanel :title="'Аккаунт'" @close="panelClose" :show="panelShow">
    <pre>{{this.panelData}}</pre>
  </LeftPanel>
  <DataTable
      :columns="columns"
      :data="accountList"
      @row-dblclick="showAccount">
  </DataTable>
</template>

<script>
import LeftPanel from "@/components/panel/LeftPanel.vue";
import DataTable from "@/components/DataTable.vue";

export default {
  name: 'AccountListPage',
  components: {DataTable, LeftPanel},
  data() {
    return {
      panelShow: false,
      panelData: null,
      accountList: null,
      columns: [
        {
          name: "id",
          title: "ID",
        },
        {
          name: "name",
          title: "Name",
        },
        {
          name: "createdAt",
          title: "Создан",
        },
        {
          name: "demoData",
          title: "DEMO",
        },
        {
          name: "freeEndDate",
          title: "freeEndDate",
        }
      ]
    }
  },
  methods: {
    panelClose() {
      this.panelShow = false;
      this.panelData = null;
    },
    showAccount(item) {
      console.log("show tariff", item)
      this.panelShow = true;
      this.panelData = item;
    },
    loadAccountList: function () {
      console.log("load user list")
      let c = this;
      this.axios.get('/api/admin/account', this.formData).then(function(response) {
        console.log(response.data);
        c.accountList = response.data.data;
      }).catch(function(err) {
        console.log(err.status);
      });
    }
  },
  mounted() {
    this.loadAccountList()
  }
}
</script>

<style scoped>

</style>